module.exports = __webpack_public_path__ + "img/pg.e0fee1f3.jpg";